import { render, staticRenderFns } from "./visaItems.vue?vue&type=template&id=10890b95&scoped=true&"
import script from "./visaItems.vue?vue&type=script&lang=js&"
export * from "./visaItems.vue?vue&type=script&lang=js&"
import style0 from "./visaItems.vue?vue&type=style&index=0&id=10890b95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10890b95",
  null
  
)

export default component.exports